import { isPlatformBrowser } from "@angular/common";
import { OnInit, } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
var PaymentReviewComponent = /** @class */ (function () {
    function PaymentReviewComponent(platformId, app, router, rest, formDataService, countIncart, _lightbox, modalService, localStorage) {
        this.platformId = platformId;
        this.app = app;
        this.router = router;
        this.rest = rest;
        this.formDataService = formDataService;
        this.countIncart = countIncart;
        this._lightbox = _lightbox;
        this.modalService = modalService;
        this.localStorage = localStorage;
        this.node_static_url = environment.node_static_url;
        this.invoice_uuid = "";
        this.total = 0;
        this.countTotal = 0;
        this.isEmptyCart = false;
        this.timeLeft = 0;
        this.model = {};
        this.isCheckOut = false;
        this._albumsPhoto = [];
        this._albumsPassport = [];
        this._albumsCover = [];
        this._albumProoFile = [];
        this.proofileCol = false;
        this.data = {
            session_id: "",
            input_id: "",
            input_value: "",
        };
    }
    PaymentReviewComponent.prototype.ngOnInit = function () {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.person = this.formDataService.getFormData();
        var authInfo = null;
        try {
            var raw = localStorage.getItem(environment.localAuthenInfo);
            if (raw && raw !== "null" && raw !== "undefined") {
                authInfo = JSON.parse(raw);
            }
        }
        catch (e) {
            console.warn("Failed to parse localAuthenInfo in payment-review:", e);
        }
        if (authInfo && authInfo.token) {
            this.person.token = authInfo.token;
            this.getData();
        }
        else {
            this.router.navigate(["/apply"]);
        }
    };
    PaymentReviewComponent.prototype.getData = function () {
        this.person.currentActiveForm = "3";
        this.onGetPersonInfo();
        this.countIncart.funcCountCart();
    };
    PaymentReviewComponent.prototype.addMorePerson = function () {
        this.formData = this.formDataService.resetFormData();
        this.router.navigate(["/application"]);
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = "addMorePeople";
        this.data.input_value = "add_more_people";
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
    };
    PaymentReviewComponent.prototype.calculateTotal = function () {
        this.countTotal = this.mDataArrayPerson.length;
    };
    PaymentReviewComponent.prototype.backToCart = function (event) {
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = event.target.id;
        this.data.input_value = "back_to_cart";
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
        this.router.navigate(["/cart"]);
    };
    PaymentReviewComponent.prototype.open = function (content) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.startTimer();
        this.modalService.open(content, { centered: true });
    };
    PaymentReviewComponent.prototype.openPhoto = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsPhoto, index, { centerVertically: true });
        }
    };
    PaymentReviewComponent.prototype.openPassport = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsPassport, index, {
                centerVertically: true,
            });
        }
    };
    PaymentReviewComponent.prototype.openCover = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsCover, index, { centerVertically: true });
        }
    };
    PaymentReviewComponent.prototype.closeImgPreview = function () {
        this._lightbox.close();
    };
    PaymentReviewComponent.prototype.startTimer = function () {
        var _this = this;
        this.interval = setInterval(function () {
            _this.timeLeft += 20;
            if (_this.timeLeft === 100) {
                clearInterval(_this.interval);
                _this.modalService.dismissAll();
                _this.countIncart.funcCountCart();
                _this.onGetPersonInfo();
            }
        }, 1000);
    };
    PaymentReviewComponent.prototype.onGetPersonInfo = function () {
        var _this = this;
        this.rest.getPersonForPayment().subscribe(function (result) {
            if (result.length > 0) {
                _this.mDataArrayPerson = result;
                _this.calculateTotal();
                _this.invoice_uuid = result[0].invoice_uuid;
                var m_total = 0;
                for (var i = 0; i < result.length; i++) {
                    m_total += result[i].price;
                }
                _this.total = Math.round(m_total * 100) / 100 || 0;
            }
            else {
                _this.mDataArrayPerson = result;
                _this.isEmptyCart = true;
                _this.total = 0;
            }
            _this.onLoadImage(result);
        });
    };
    PaymentReviewComponent.prototype.onLoadImage = function (person) {
        var _this = this;
        var _loop_1 = function (i) {
            if (person[i].version == "2") {
                this_1.rest.getBase64ImageService(person[i].photo_name, "photo").subscribe(function (result) {
                    _this._albumsPhoto.push({
                        src: result["photo_name"],
                        caption: "Photo "
                    });
                    _this.mDataArrayPerson[i].photo_name = result["photo_name"];
                });
                this_1.rest.getBase64ImageService(person[i].passport_name, "passport").subscribe(function (result) {
                    _this._albumsPassport.push({
                        src: result["passport_name"],
                        caption: "Passport "
                    });
                    _this.mDataArrayPerson[i].passport_name = result["passport_name"];
                });
            }
            else {
                this_1.mDataArrayPerson[i].photo_name = person[i].photo_name;
                this_1._albumsPhoto.push({
                    src: person[i].photo_name,
                    caption: "Photo "
                });
                this_1.mDataArrayPerson[i].passport_name = person[i].passport_name;
                this_1._albumsPassport.push({
                    src: person[i].passport_name,
                    caption: "Passport "
                });
            }
        };
        var this_1 = this;
        for (var i = 0; i < person.length; i++) {
            _loop_1(i);
        }
    };
    return PaymentReviewComponent;
}());
export { PaymentReviewComponent };
